import React from "react"
import Modal from './index'

const ModalInfo = ({ icon, title = "", description = "", content = "", fitContent = false, closeModal }) => {
    return (
        <Modal
            icon={icon}
            title={title}
            description={description}
            fitContent={fitContent}
            closeModal={closeModal}
        >
            {content}
        </Modal>
    )
}

export default ModalInfo